import BaseContainer from "@/components/baseContainer";
import LoginForm from "@/components/form/loginForm";
import { WP_URL } from "@/config";
import { linkToIframe } from "@/utiils";

const LoginPage = () => {
  const onLoginComplete = () => {
    linkToIframe('/user', {isIframeUrl: WP_URL + '/mypage'});
  };

  const onRegister = () => {
    linkToIframe('/user/register', {isIframeUrl: WP_URL + '/register'});
  };

  return (
    <div className="my-16">
      <BaseContainer>
        <LoginForm onComplete={onLoginComplete} />
      </BaseContainer>
      <div className="mt-12 text-center px-8">
        <p>利用登録がお済みでない方は<br className="xmd:hidden" />こちらの利用登録画面へお進みください。</p>
        <div className="flex justify-center mt-8">
          <button type="button" className="m-btn outlined btn-sun" onClick={onRegister}><em className="m-icon-register -mt-1 mr-2 text-[2.4rem]"></em><span>利用登録（無料）</span></button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;